export default __webpack_public_path__ + "static/media/avatar_mei_ling8.6c33f5dd.mp3";